import { render } from "./BrandingCopy.vue?vue&type=template&id=5a2a6962&scoped=true"
import script from "./BrandingCopy.vue?vue&type=script&lang=js"
export * from "./BrandingCopy.vue?vue&type=script&lang=js"

import "./BrandingCopy.vue?vue&type=style&index=0&id=5a2a6962&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2a6962"]])

export default __exports__